  <div class="flex-start flex h-1.5 min-w-full overflow-hidden rounded bg-blue-gray-50">
    <div class="flex items-center justify-center h-full overflow-hidden text-white break-all bg-cyan-600 rounded-1/4"
      [ngStyle]="{'width': progressPercentage}">
    </div>
  </div>